export default __webpack_public_path__ + "static/media/paper-1.eac6be84.pdf";